// WHERE A MOVED SIGN-OFF WAS FIRST PLANNED (owner, 2026-10-10).
//
// Moving a sign-off keeps the first planned day on the row
// (signOffDateOriginal, see back/utils/signOffOriginal). The chart draws a
// grey star there; the printed Gantt draws the same star and, because paper
// cannot hover, says "was <day>" in its sign-off column. One rule for both.

const dayKey = (v) => {
  if (!v) return "";
  const d = new Date(v);
  return Number.isNaN(+d) ? "" : d.toISOString().slice(0, 10);
};

/** The first planned sign-off day (YYYY-MM-DD) when it differs from the
 *  current one, else null - including rows that were never moved. */
export function movedSignOff(item) {
  const now = dayKey(item && item.signOffDate);
  const was = dayKey(item && item.signOffDateOriginal);
  return now && was && was !== now ? was : null;
}
